export enum GroupEmployeeStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const GroupEmployeeStatusOptions = [
  {
    label: "Active",
    value: GroupEmployeeStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: GroupEmployeeStatus.INACTIVE,
  },
];
